<template>
    <div>

        <div v-if="editAjuda && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitAjuda" v-if="!editAjuda || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editAjuda || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                            <el-input v-model="dados.titulo" maxlength="191" v-on:blur="formatData('titulo')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="reset-text-transform">
                        <el-form-item label="Descrição" prop="descricao" :rules="[$requiredBlur]" key="descricao">
                            <div style="margin: 20px 0px;">
                                <ckeditor v-model="dados.descricao" :config="{ extraPlugins: 'tableresize,divarea' }"></ckeditor>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="reset-text-transform">
                        <el-form-item label="Url Vídeo" prop="url" :rules="[$requiredBlur]" key="url">
                            <el-input v-model="dados.url" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="reset-text-transform">
                        <el-form-item label="Tags" prop="tags" :rules="[$requiredBlur]" key="tags">
                            <el-input v-model="dados.tags" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-ajuda" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

import ckeditor from '@/shared/ckeditor/ckeditor'

export default {
    props: ['paramId'],
    data: () => ({
        editAjuda: false,
        alert: false,
        dados: {
            id: '',
            tags: '',
            situacao: '',
            nome: ''
        }

    }),
    mounted () {

    },
    methods:{
        getAjudaById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ajuda/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitAjuda(){

            document.getElementById("btn-ajuda").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editAjuda){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ajuda/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitAjuda');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ajuda/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitAjuda');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormAjuda(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAjudaById(value);
                    this.editAjuda = true;
                } 
            }
        },
    },
    components: { ckeditor }
}
</script>
